import { ONBOARDING_STEPS, TOTAL_STEPS } from './onboardingSteps.config';
import { STEP_ORDER } from './constants';

export function getResumeStep(steps) {
  for (const key of STEP_ORDER) {
    const status = steps[key];
    if (status !== 'completed' && status !== 'skipped') {
      const step = ONBOARDING_STEPS.find((s) => s.key === key);
      return step?.id ?? 1;
    }
  }
  return TOTAL_STEPS;
}

export function getProgressPercent(steps) {
  const required = ONBOARDING_STEPS.filter((s) => s.required);
  const completed = required.filter((s) => steps[s.key] === 'completed').length;
  return Math.round((completed / required.length) * 100);
}

export function canNavigateToStep(targetStep, steps) {
  const resume = getResumeStep(steps);
  const config = ONBOARDING_STEPS.find((s) => s.id === targetStep);
  if (!config) return false;
  const status = steps[config.key];
  if (status === 'completed' || status === 'skipped') return true;
  return targetStep <= resume;
}

export function clampStep(step) {
  if (Number.isNaN(step) || step < 1) return 1;
  if (step > TOTAL_STEPS) return TOTAL_STEPS;
  return step;
}
